import * as types from '../types/orderTypes';

const initialState = {
  orders: [],
  order: null,
  stats: null,
  loading: false,
  error: null,
};

function orderReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_ORDERS_REQUEST:
    case types.FETCH_ORDER_STATS_REQUEST:
    case types.FETCH_ORDER_BY_ID_REQUEST:
    case types.UPDATE_ORDER_STATUS_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_ORDERS_SUCCESS:
      return { ...state, loading: false, orders: action.payload };

    case types.FETCH_ORDER_STATS_SUCCESS:
      return { ...state, loading: false, stats: action.payload };

    case types.FETCH_ORDER_BY_ID_SUCCESS:
      return { ...state, loading: false, order: action.payload };

    case types.UPDATE_ORDER_STATUS_SUCCESS:
      const updated = action.payload;
      return {
        ...state,
        loading: false,
        orders: state.orders.map((o) => (o._id === updated._id ? updated : o)),
        order: state.order && state.order._id === updated._id ? updated : state.order,
      };

    case types.FETCH_ORDERS_FAILURE:
    case types.FETCH_ORDER_STATS_FAILURE:
    case types.FETCH_ORDER_BY_ID_FAILURE:
    case types.UPDATE_ORDER_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}

export default orderReducer;
